import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import './switcher.scss';

const Switcher = ({ items, selected, setSelected }) => (
    items.length <= 1 ? null : (
        <div className="cmn-switcher">
            {items.map((item, index) => (
                <button
                    className={classNames(
                        'ui-btn', 'cmn-switcher__btn',
                        'ui-switcher__btn',
                        index === selected ? 'ui-btn_primary' : 'ui-btn_secondary'
                    )}
                    key={item}
                    onClick={() => setSelected(index)}
                >
                    {item}
                </button>
            ))}
        </div>
    )
);

Switcher.propTypes = {
    items: PropTypes.arrayOf(PropTypes.string).isRequired,
    selected: PropTypes.number.isRequired,
    setSelected: PropTypes.func.isRequired
};

export default Switcher;



// WEBPACK FOOTER //
// ./~/rp-react-common/src/Switcher/Switcher.jsx